module.exports = __webpack_public_path__ + "static/media/service4.d5ab41ad.jpg";